@if (searchResult.filter) {
  <div class="result-count">
    Sökresultat: {{searchResult.result.length}} {{isSkogsvardFPV ? "Skogsvårdsuppdrag" : "kontrakt"}}
  </div>
}
@if (asyncDataLoaded) {
  <rask-list [data]="searchResult.result" [virtualScroll]="true" virtualScrollType="window"
    [virtualScrollItemHeight]="36" [fixedHeader]="true" key="kontraktId">
    <rask-list-column [header]="texts.avtalsnr" field="avtalnummer" [sortable]="true" width="80px">
      <ng-template let-row="row">
        <a [routerLink]="[row.avtalId]">
          {{ row.avtalnummer }}
        </a>
      </ng-template>
    </rask-list-column>
     @if(isSkogsvardFPV){
      <rask-list-column header="Benämning Avtal" field="avtalbenamning" [sortable]="true" width="200px"></rask-list-column>
    }
    <rask-list-column [header]="texts.kontraktnr" field="kontraktnummer" [sortable]="true" width="90px">
      <ng-template let-row="row">
        <a
          [routerLink]="[row.avtalId]"
          [queryParams]="{ kontraktId: row.kontraktId}">
          {{ row.kontraktnummer }}
        </a>
      </ng-template>
    </rask-list-column>
    <rask-list-column [header]="texts.kontraktbenamning" field="kontraktbenamning" [sortable]="true">
      <ng-template let-row="row">
        <a
          [routerLink]="[row.avtalId]"
          [queryParams]="{ kontraktId: row.kontraktId}">
          {{ row.kontraktbenamning }}
        </a>
      </ng-template>
    </rask-list-column>
    @if(isSkogsvardFPV){
      <rask-list-column header="Kund" field="kund" [sortable]="true" width="200px">
        <ng-template let-row="row">
          {{ row.kund }} ({{ row.kundKod }})
        </ng-template>
      </rask-list-column>
    }
    @else{
    <rask-list-column  header="AF" field="affarsform" [sortable]="true" width="60px"></rask-list-column>
    <rask-list-column [header]="texts.leverantor" field="leverantor" [sortable]="true" width="200px"></rask-list-column>
    <rask-list-column  header="Kontraktstyp" field="typ" [sortable]="true" width="110px"></rask-list-column>
  }
  <rask-list-column header="Åtgärdstyp" field="atgardsTyper" [sortable]="true" width="300px" [nowrap]="true"
    [sortString]="getFormattedAtgardsTyperOneLine">
    <ng-template let-row="row">
      <ng-template #tooltipContent>
        <div class="atgardtyper-tooltip">
          @for (atgardsTypGrupp of row.atgardstypMultiLine; track atgardsTypGrupp) {
            <div class="atgardsgrupp">{{atgardsTypGrupp.name}}</div>
            @for (atgardstyp of atgardsTypGrupp.typer; track atgardstyp) {
              <div class="atgardstyp" [ngClass]="{'selected': atgardstyp.selected}"><span
              class="atgardantal">{{atgardstyp.count}}</span>{{atgardstyp.name}}</div>
            }
          }
        </div>
      </ng-template>
      <div [ngbTooltip]="row.atgardsTyper?.length ? tooltipContent: ''" tooltipClass="anbudkontrakt-tooltip"
        container="body" class="ellipsis">
        {{ row.atgardstypSingleLine }}
      </div>
    </ng-template>
  </rask-list-column>
  <rask-list-column [header]="texts.kontraktstatus" field="kontraktstatus" [sortable]="true"
  width="110px"></rask-list-column>
  <rask-list-column [header]="" field="visaVarningGiltighetstid" width="14px">
    <ng-template let-row="row">
      @if (row.visaVarningGiltighetstid) {
        <i class="far fa-exclamation-square error-giltighetsdatum"></i>
      }
    </ng-template>
  </rask-list-column>
  @if (!isSkogsvardFPV) {
    <rask-list-column [header]="texts.giltighetstid" field="giltighetsdatumTom" [sortable]="true" width="110px">
      <ng-template let-row="row">
        {{row.giltighetsdatumTom | date:'yyyy-MM-dd'}}
      </ng-template>
    </rask-list-column>
  }
  <rask-list-column [header]="texts.senastAndrad" field="senastandrad" [sortable]="true" width="110px">
    <ng-template let-row="row">
      {{row.senastandrad | date:'yyyy-MM-dd'}}
    </ng-template>
  </rask-list-column>
  @if (!isSkogsvardFPV) {
    <rask-list-column header="Violversion" [sortable]="true" field="viol3" width="90px">
      <ng-template let-row="row">
        {{ getViolVersion(row) }}
      </ng-template>
    </rask-list-column>
  }
  @if (isKopledaOrVirkeskopa || isSkogsvardFPV) {
    <rask-list-column [header]="texts.makulera" field="" width="90px">
      <ng-template let-row="row">
        @if (row.kontraktstatus === statusKontrakt) {
          <div>
            <rask-icon-button negative (click)="onMakulera(row)" icon="far fa-trash-alt fa-lg"></rask-icon-button>
          </div>
        }
      </ng-template>
    </rask-list-column>
  }
</rask-list>
}